import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AzmoonMaharatDetail_SignIn_Interface, Empty_AzmoonMaharatDetail_SignIn_Interface } from 'src/app/Interface/AzmoonMaharatDetail_SignIn_Interface';
import { AzmoonMaharatMain_Interface, Empty_AzmoonMaharatMain_Interface } from 'src/app/Interface/AzmoonMaharatMain_Interface';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { AzmoonMaharatService } from 'src/app/Service/AzmoonMaharat/AzmoonMaharat.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-AzmoonMaharatMainSignInList',
  templateUrl: './AzmoonMaharatMainSignInList.component.html',
  styleUrls: ['./AzmoonMaharatMainSignInList.component.css']
})
export class AzmoonMaharatMainSignInListComponent implements OnInit {
  Filter_title: string = ""
  Filter_dsc: string = ""
  Filter_CodeBehfa: string = ""
  Filter_Filter_Type: string = "0"
  page: number = 0;
  Procssing: boolean = false

  modalRef_Delete: any;
  modalRef_Edit: any;

  constructor(
    private AzmoonMaharat_Service: AzmoonMaharatService,
    private Alertify_Service: AlertifyService,
    private Nav_Service: NavService,
    private modalService: BsModalService
  ) { }


  DataList_AzmoonMaharat: Array<AzmoonMaharatDetail_SignIn_Interface> = []
  DataList_AzmoonMaharat_Group: Array<General_Interface> = []
  Selected_AzmoonMaharat_Group: General_Interface = Empty_General_Interface()

  ngOnInit() {
    this.Nav_Service.CheckValidPage(2219).subscribe(
      data => {
        this.ReadData_AzmoonMaharat()
      }
      , error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }

  ReadData_AzmoonMaharat() {
    this.Procssing = true
    this.AzmoonMaharat_Service.GetSignIn(Number(this.Filter_Filter_Type)).subscribe(
      data => {
        this.DataList_AzmoonMaharat = data
        this.ReadData_AzmoonMaharat_Group()
        this.Procssing = false
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  ReadData_AzmoonMaharat_Group() {
    this.DataList_AzmoonMaharat_Group = []
    for (let item of this.DataList_AzmoonMaharat) {
      if (this.ReadData_AzmoonMaharat_Group_Co(item)) {
        var temp: General_Interface = Empty_General_Interface()
        temp.id = 1
        temp.title = item.title
        this.DataList_AzmoonMaharat_Group.push(temp)
      }
    }
  }

  ReadData_AzmoonMaharat_Group_Co(model: AzmoonMaharatDetail_SignIn_Interface) {

    for (let item of this.DataList_AzmoonMaharat_Group) {
      if (item.title == model.title) {
        return false;
      }
    }
    return true
  }

  Change_Filter_title() {
    this.page = 0
    this.ReadData_AzmoonMaharat_Group()
  }

  Set_Selected_AzmoonMaharat_Group(item: General_Interface) {
    this.Selected_AzmoonMaharat_Group = item
  }

  Back_Selected_AzmoonMaharat_Group() {
    this.Selected_AzmoonMaharat_Group = Empty_General_Interface()
  }

  //#region AzmoonMaharat Form

  Selected_AzmoonMaharat_Record: AzmoonMaharatMain_Interface
  Selected_AzmoonMaharat_Record_Switcher: string = 'List'
  Set_List_AzmoonMaharat_View() {
    this.ReadData_AzmoonMaharat()
    this.Selected_AzmoonMaharat_Record_Switcher = 'List'
  }

  Set_Form_AzmoonMaharat_View(item: AzmoonMaharatMain_Interface, Switcher: string) {
    this.Selected_AzmoonMaharat_Record = item
    this.Selected_AzmoonMaharat_Record_Switcher = Switcher
  }

  Set_Form_AzmoonMaharat_View_Add() {
    this.Selected_AzmoonMaharat_Record = Empty_AzmoonMaharatMain_Interface()
    this.Selected_AzmoonMaharat_Record_Switcher = 'Form'
  }

  //#endregion


  Data_Seleted_Delete:AzmoonMaharatDetail_SignIn_Interface=Empty_AzmoonMaharatDetail_SignIn_Interface()
  Delete(item: AzmoonMaharatDetail_SignIn_Interface) {
    this.Procssing = true
    this.modalRef_Delete.hide()
    this.AzmoonMaharat_Service.DeleteRequest(item.id,this.Filter_dsc ).subscribe(
      data => {
        this.Alertify_Service.SuccessMessage("حذف شد")
        this.ReadData_AzmoonMaharat()
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }

  Edit(item: AzmoonMaharatDetail_SignIn_Interface) {
    this.Procssing = true
    this.modalRef_Edit.hide()
    this.AzmoonMaharat_Service.EditRequest(item.id,this.Filter_CodeBehfa ).subscribe(
      data => {
        this.Alertify_Service.SuccessMessage("ویرایش شد")
        this.ReadData_AzmoonMaharat()
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }

  openModal(template: TemplateRef<any>, Record) {
    this.Data_Seleted_Delete = Record
    this.Filter_dsc=''
    this.modalRef_Delete = this.modalService.show(template);
  }

  openModalEdit(template: TemplateRef<any>, Record) {
    this.Data_Seleted_Delete = Record
    this.Filter_CodeBehfa=''
    this.modalRef_Edit = this.modalService.show(template);
  }


}
